module.exports = __webpack_public_path__ + "img/copper.0ff59382.png";